import { useCallback, useEffect, useRef, useState } from "react"
import { unstable_batchedUpdates } from "react-dom"

const Index = ({ placeholder, toggle, value: controlledValue = "" }) => {
  const [show, setShow] = useState(false);
  const [value, setValue] = useState(controlledValue || "");
  const didMount = useRef(false);
  const inputRef = useRef(null);
  const toggleRef = useRef(toggle);
  const controlledValueRef = useRef(controlledValue);
  const skipDebounce = useRef(false);

  const isOpen = show || value.length > 0;

  const notifyChange = useCallback((nextValue) => {
    if (toggleRef.current) {
      unstable_batchedUpdates(() => {
        toggleRef.current(nextValue);
      });
    }
  }, []);

  useEffect(() => {
    toggleRef.current = toggle;
  }, [toggle]);

  useEffect(() => {
    if (controlledValue === controlledValueRef.current) return;
    controlledValueRef.current = controlledValue;
    const nextValue = controlledValue || "";
    if (nextValue !== value) {
      skipDebounce.current = true;
      setValue(nextValue);
    }
  }, [controlledValue, value]);

  useEffect(() => {
    if (isOpen) {
      inputRef.current?.focus();
    }
  }, [isOpen]);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }

    if (skipDebounce.current) {
      skipDebounce.current = false;
      return;
    }

    const timer = setTimeout(() => {
      notifyChange(value);
    }, 400);

    return () => clearTimeout(timer);
  }, [notifyChange, value]);

  function handleInputChange(event) {
    setValue(event.target.value);
  }

  function handleClear(event) {
    event.stopPropagation();

    if (!value) {
      setShow(false);
      return;
    }

    skipDebounce.current = true;
    setValue("");

    notifyChange("");
  }

  return (
    <div className={`search-container ${isOpen ? "is-open" : ""}`}>
      <div className="search-field mini-hide">
        <span className="material-icons-round search-field-icon">search</span>
        <input
          ref={inputRef}
          className="input-search"
          placeholder={placeholder}
          value={value}
          onChange={handleInputChange}
        />
        <button
          type="button"
          className="search-clear"
          aria-label="Bersihkan pencarian"
          onClick={handleClear}
        >
          <span className="material-icons-round">close</span>
        </button>
      </div>
      <button
        type="button"
        className="button search-toggle mini-hide"
        onClick={() => setShow(true)}
        aria-label="Buka pencarian"
      >
        <span className="material-icons-round icon-only mini-hide">search</span>
      </button>

      {/* Showing search bar */}
      <div
        className="mini-show search-field mobile-search-field"
      >
        <span className="material-icons-round search-field-icon">search</span>
        <input
          className="input-search"
          placeholder={placeholder}
          value={value}
          onChange={handleInputChange}
        />
        <button
          type="button"
          className="search-clear"
          aria-label="Bersihkan pencarian"
          onClick={handleClear}
        >
          <span className="material-icons-round">close</span>
        </button>
      </div>
    </div>
  );
};

export default Index;
